import React from "react";

const Title = ({...props}) => {
    return (
        <h2 className="mb-2 uppercase font-bold text-2xl">{props.children}</h2>
    )
}

export default Title;